import { render, staticRenderFns } from "./button-green.vue?vue&type=template&id=5216b4e9"
import script from "./button-green.vue?vue&type=script&lang=js"
export * from "./button-green.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports